"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldSizePropTypes = exports.fieldSizeDefaultProps = exports.default = exports.FieldSize = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

let FieldSize = /*#__PURE__*/function (FieldSize) {
  FieldSize["DEFAULT"] = "DEFAULT";
  FieldSize["SMALL"] = "SMALL";
  return FieldSize;
}({});

exports.FieldSize = FieldSize;
var _default = FieldSize;
exports.default = _default;
const fieldSizePropTypes = {
  size: _propTypes.default.oneOf(['DEFAULT', 'SMALL'])
};
exports.fieldSizePropTypes = fieldSizePropTypes;
const fieldSizeDefaultProps = {
  size: 'DEFAULT'
};
exports.fieldSizeDefaultProps = fieldSizeDefaultProps;